import React from "react";
import cx from "classnames";
// import PropTypes from 'prop-types'
import { BookingDetailInfoStyled } from "./styled";
import moment from "moment";
import { RENDER_EVENT_TYPE } from "utils/functions/musicHall";
import { RENDER_BOOKING_DATE_CHANGED } from "utils/functions/roomBooking";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import i18n from "i18n";
import { IMG_PATH } from "utils/constants/imgPath";
import { Buttons } from "components";

const BookingDetailInfo = ({
  theme_standard,
  additional_equipment,
  alternative_booking_dates,
  booker_email,
  booker_first_name,
  booker_last_name,
  booking_date,
  booking_date_history,
  created_at,
  event_name,
  event_type,
  expected_attendees,
  room_name_en,
  room_name_th,
  room_type,
  setup_cleanup_start_time,
  setup_cleanup_end_time,
  event_start_time,
  event_end_time,
  special_request,
  special_request_img,
}) => {
  const customClass = cx({
    theme_standard: theme_standard,
  });

  const { t } = useTranslation(["common", "form", "room"]);
  const navigate = useNavigate();

  const _handleBack = () => {
    navigate(-1);
  };

  const dateChanged = RENDER_BOOKING_DATE_CHANGED(
    booking_date,
    booking_date_history,
  );

  let reduceAddtional = !additional_equipment
    ? {
        additional_equipment_provider: [],
        additional_equipment_additional: [],
      }
    : additional_equipment.reduce(
        (result, data) => {
          if (data.subtotal === 0) {
            result.additional_equipment_provider.push(data);
          } else {
            result.additional_equipment_additional.push(data);
          }
          return result;
        },
        {
          additional_equipment_provider: [],
          additional_equipment_additional: [],
        },
      );
  return (
    <BookingDetailInfoStyled className={customClass}>
      <div className="booking_detail_header">
        <div className="booking_detail_title ">
          {t("Booking Details", { ns: "room" })}
        </div>
      </div>
      <div className="booking">
        <div className="booking_header color_purple">
          {i18n.language === "en" ? room_name_en : room_name_th}
        </div>
        <div className="booking_header">
          {/* ห้องซ้อมใช้ "รายละเอียดผู้เข้าใช้บริการ" music hall ยังใช้คำเดิม */}
          1.{" "}
          {room_type === "2"
            ? t("Service User Details", { ns: "room" })
            : t("Contact Information (Event Host/Coordinator)", { ns: "room" })}
        </div>
        <div className="booking_detail_row">
          <div className="title">{t("Create date", { ns: "common" })}</div>
          <div className="text ">{moment(created_at).format("DD/MM/YYYY")}</div>
        </div>
        <div className="booking_detail_row">
          <div className="title">{t("Time", { ns: "common" })}</div>
          <div className="text ">
            {event_start_time} - {event_end_time}
          </div>
        </div>
        <div className="booking_detail_row">
          <div className="title">{t("First Name", { ns: "form" })}</div>
          <div className="text ">{booker_first_name}</div>
        </div>
        <div className="booking_detail_row">
          <div className="title">{t("Last Name", { ns: "form" })}</div>
          <div className="text ">{booker_last_name}</div>
        </div>
        <div className="booking_detail_row">
          <div className="title">{t("Email", { ns: "form" })}</div>
          <div className="text ">{booker_email}</div>
        </div>
      </div>

      <div className="booking">
        <div className="booking_header">
          2. {t("Booking details", { ns: "room" })}
        </div>
        <div className="booking_detail_row">
          <div className="title">{t("Event Date", { ns: "room" })}</div>
          <div className="text ">
            {moment(booking_date).format("DD/MM/YYYY")}
          </div>
        </div>
        {dateChanged && (
          <div className="booking_detail_row">
            <div className="title">
              {t("Event date changed from", { ns: "room" })}
            </div>
            <div className="text ">
              {moment(dateChanged.from).format("DD/MM/YYYY")}
              {dateChanged.reason ? ` - ${dateChanged.reason}` : ""}
            </div>
          </div>
        )}
        {room_type === "1" &&
          alternative_booking_dates &&
          alternative_booking_dates.length > 0 && (
            <div className="booking_detail_row">
              <div className="title">
                {t("Alternative Event Date", { ns: "room" })}
              </div>
              <div className="text ">
                {alternative_booking_dates.map((e, i) => (
                  <div key={i}>
                    {moment(e.booking_date).format("DD/MM/YYYY")}{" "}
                    {e.event_start_time} - {e.event_end_time}
                  </div>
                ))}
              </div>
            </div>
          )}
        {room_type === "1" && setup_cleanup_start_time && (
          <div className="booking_detail_row">
            <div className="title">
              {t("Set-up & Clean-out Time", { ns: "room" })}
            </div>
            <div className="text ">
              {setup_cleanup_start_time} - {setup_cleanup_end_time}
            </div>
          </div>
        )}
        <div className="booking_detail_row">
          <div className="title">{t("Exact Event Time", { ns: "room" })}</div>
          <div className="text ">
            {event_start_time} - {event_end_time}
          </div>
        </div>
      </div>
      {/* ห้องซ้อม: หมายเหตุที่ลูกค้ากรอกตอนเลือกเวลา (เก็บใน special_request) แสดงเฉพาะตอนมี */}
      {room_type === "2" && special_request && (
        <div className="booking">
          <div className="booking_header">3. {t("Note", { ns: "room" })}</div>
          <div className="booking_detail_row">
            <div className="text note_text">{special_request}</div>
          </div>
        </div>
      )}
      {room_type === "1" && (
        <>
          {(event_name || RENDER_EVENT_TYPE(event_type).labelEn) && (
            <div className="booking">
              <div className="booking_header">
                3. {t("Event Details", { ns: "room" })}
              </div>
              {event_name && (
                <div className="booking_detail_row">
                  <div className="title">{t("Event Name", { ns: "form" })}</div>
                  <div className="text ">{event_name}</div>
                </div>
              )}
              {RENDER_EVENT_TYPE(event_type).labelEn && (
                <div className="booking_detail_row">
                  <div className="title">
                    {t("Type of Event", { ns: "form" })}
                  </div>
                  <div className="text ">
                    {RENDER_EVENT_TYPE(event_type).labelEn}
                  </div>
                </div>
              )}
            </div>
          )}
          {!!expected_attendees && (
            <div className="booking">
              <div className="booking_header">
                4. {t("Number of Guests", { ns: "room" })}
              </div>
              <div className="booking_detail_row">
                <div className="title">
                  {t("Number of Guests", { ns: "room" })}
                </div>
                <div className="text ">{expected_attendees}</div>
              </div>
            </div>
          )}
          {reduceAddtional.additional_equipment_provider.length > 0 && (
            <div className="booking">
              <div className="booking_header">
                5.{" "}
                {t("Equipment Provided (Free of Charge)", {
                  ns: "room",
                })}
              </div>
              <div className="booking_detail_row">
                <div className="text ">
                  {reduceAddtional.additional_equipment_provider
                    .map((e) => e.equipment_name_th)
                    .join(", ")}
                </div>
              </div>
            </div>
          )}
          {reduceAddtional.additional_equipment_additional.length > 0 && (
            <div className="booking">
              <div className="booking_header">
                6.{" "}
                {t("Additional Equipment (Optional Extras)", {
                  ns: "room",
                })}
              </div>
              <div className="booking_detail_row">
                <div className="text ">
                  {reduceAddtional.additional_equipment_additional
                    .map((e) => e.equipment_name_th)
                    .join(", ")}
                </div>
              </div>
            </div>
          )}
          {special_request_img && special_request_img.length > 0 && (
            <div className="booking">
              <div className="booking_header">
                7. {t("Upload Picture", { ns: "common" })}
              </div>
              {special_request_img.map((img, idx) => (
                <div key={idx} className="img_row">
                  <img
                    src={img ? IMG_PATH + img : ""}
                    alt={`special_request_${idx + 1}`}
                  />
                </div>
              ))}
            </div>
          )}
        </>
      )}
      <div className="booking_back_button">
        <Buttons.BgStandard
          theme_white_purple
          label={t("Back", { ns: "common" })}
          onClick={_handleBack}
        />
      </div>
    </BookingDetailInfoStyled>
  );
};

BookingDetailInfo.propTypes = {};

export default BookingDetailInfo;
